/* eslint-disable */
import React, { forwardRef } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import FiatBrand from '~/components/FiatBrand/FiatBrand';
import css from './CarBrand.scss';

const classes = {
	root: css.carBrand,
	image: css.carBrandImage,
	text: css.carBrandText,
};

const propTypes = {
	...FiatBrand.propTypes,
};

const defaultProps = {
	...FiatBrand.defaultProps,
	classes,
	stripes: 'italian',
};

export const CarBrand = forwardRef(({
	className,
	classes,
	...props
}, ref) => {
	return (
		<div className={cls(classes.root, className)}>
			<FiatBrand
				ref={ref}
				{...props}
				className={cls(classes.image)}
			/>
			<p className={cls(classes.text)}>
				FIAT STRADA
			</p>
		</div>
	);
});

CarBrand.displayName = 'CarBrand';
CarBrand.propTypes = propTypes;
CarBrand.defaultProps = defaultProps;
export default CarBrand;
